import page from '../../../components/page.vue'
import search from '../../../components/search.vue'
import {api,imgPath} from '../../../common/config.js'
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {store} from '../../../store/store.js';
import {CommonUtil} from '../../../common/CommonUtil.js';
export default {
  name: 'referbook',
  data(){
    return {
      categoryId: 0,
      isCategaoy: false,
      imgError: store.imgError,
      wellBook: {},
      firstList: [{
        isShow: false,//是否展开二级分类
        secondList: [{}, {}]
      }],
      bookCategorys:[],//分类
      chooseItem: -1,
      pageNo: 1,
      pageCount: 12,
      totalPage: 1,
      libCode: '',
      imgPath:imgPath
    }
  },
  watch: {
    $route() {
      this.queryData()
    }
  },
  beforeMount() {
    this.queryData()
  },
  components: {
    page,
    search
  },

  methods: {

    toInfo(id){
        this.$router.push({path: '/ebookinfo', query: {id: id, hallCode: this.$route.query.hallCode || ''}});
    },

    queryData() {
      this.pageNo = this.$route.query.page || 1;
      this.pageCount = this.$route.query.pageCount || 12;
      this.libCode = this.$route.query.libCode || '';
      Promise.all([this.category(api.ebook.category),this.getReferBook(api.index.recommendGoodEBooks)])
    },
    category(param) {
      ajaxUtil.ajaxJson(param, null, "GET", (data)=> {
        this.bookCategorys = data;
      }, null, this);
    },
    getReferBook(param) {
      var url =param.replace('{pageNo}', this.pageNo).replace('{pageCount}', this.pageCount);
      ajaxUtil.ajaxJson(url, null, "GET", (data)=> {
        for (let i = 0; i < data.resultList.length; i++) {
          if (data.resultList[i].recommendReason.length > 40) {
            data.resultList[i].recommendReason = data.resultList[i].recommendReason.substring(0, 40) + '...'
          }
        }
        this.wellBook = data;
        this.totalPage = data.totalPage;
      }, null, this);
    },
    //跳转到电子书首页
    onSkip(){
      this.$router.push('/book/2');
    },
    paging: function (pageNo) {
      CommonUtil.mergeQuery(this,{page: pageNo})
    },
    //跳转到分类页面
    onEbook(id, index, type, fatherId){
      this.categoryId = id;
      if(type == 0) {
        this.$router.push({path:'/book/2',query:{categoryId:id,twoLevelCategoryId: 0, chooseItem: index}});
      } else {
        this.$router.push({path:'/book/2',query:{categoryId:fatherId,twoLevelCategoryId: id, chooseItem: index}});
      }
    },
    //点击搜索
    search(keywordInput, select) {
      var searchStr = keywordInput.trim();
      if (searchStr == "") {
        this.$router.push('/');
        return;
      }
      this.$router.push({path: '/indexsearch', query:{"searchStr": searchStr, "type": 2, "code": store.chooseArea.code,"fromSearch": 0, "libCode": this.libCode}});
    },

    highSearch: function () {
      this.$router.push({path: '/searchebook', query: {type: 1, "fromSearch": 0}});
    },

    //展开二级分类
    showSubList(index){
      this.chooseItem = index == this.chooseItem?-1:index
    },
    OnCategaoy(){
      this.isCategaoy = !this.isCategaoy
    },

  }
}
